import { minimumForwardSchedule, normalizeTimeHhmm } from './marketingScheduleForward';

const TZ = 'Europe/Amsterdam';
const CONFLICT_MINUTES = 60;
const SLOT_STEP_MINUTES = 30;
const EXTRA_SLOTS = ['09:00', '09:30', '10:00', '10:30', '11:45', '14:00', '16:00', '19:00'];

export function todayIsoAmsterdam(nowMs = Date.now()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(nowMs));
}

export function timeToMinutes(hhmm) {
  const t = normalizeTimeHhmm(hhmm, '10:00');
  const [h, m] = t.split(':');
  return parseInt(h, 10) * 60 + parseInt(m, 10);
}

export function minutesToTime(totalMin) {
  const m = Math.max(0, Math.min(23 * 60 + 59, totalMin));
  const h = Math.floor(m / 60);
  const mi = m % 60;
  return `${String(h).padStart(2, '0')}:${String(mi).padStart(2, '0')}`;
}

export function occupiedInstagramMinutesOnDay(events, dayIso, defaultTime = '10:00') {
  const day = String(dayIso || '').slice(0, 10);
  return (events || [])
    .filter((e) => String(e.starts_on || '').slice(0, 10) === day)
    .filter((e) => {
      if (Number(e.instagram_auto_publish) === 1) return true;
      if (e.channel === 'meta' && (e.status === 'approved' || e.status === 'planned')) return true;
      return false;
    })
    .map((e) => timeToMinutes(e.instagram_publish_time || defaultTime));
}

function hasConflict(candidateMin, occupied, bufferMin = CONFLICT_MINUTES) {
  return occupied.some((occ) => Math.abs(occ - candidateMin) < bufferMin);
}

/**
 * Kies een posttijd op `dayIso`: start bij default (of +15 min als vandaag), vermijd overlap met geplande posts.
 */
export function suggestPublishTimeForDay({
  dayIso,
  defaultTime = '10:00',
  occupiedMinutes = [],
  nowMs = Date.now(),
}) {
  const day = String(dayIso || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return normalizeTimeHhmm(defaultTime);
  }

  const today = todayIsoAmsterdam(nowMs);
  let startMin =
    day === today
      ? timeToMinutes(minimumForwardSchedule(defaultTime, nowMs).publishTime)
      : timeToMinutes(defaultTime);

  const candidateSet = new Set();
  for (let m = startMin; m <= 21 * 60; m += SLOT_STEP_MINUTES) {
    candidateSet.add(m);
  }
  for (const t of EXTRA_SLOTS) {
    const m = timeToMinutes(t);
    if (m >= startMin - CONFLICT_MINUTES) candidateSet.add(m);
  }

  const candidates = [...candidateSet].sort((a, b) => a - b);
  for (const m of candidates) {
    if (!hasConflict(m, occupiedMinutes)) {
      return minutesToTime(m);
    }
  }

  const last = occupiedMinutes.length ? Math.max(...occupiedMinutes) : startMin;
  let fallback = last + SLOT_STEP_MINUTES;
  while (fallback <= 21 * 60 && hasConflict(fallback, occupiedMinutes)) {
    fallback += SLOT_STEP_MINUTES;
  }
  return minutesToTime(fallback <= 21 * 60 ? fallback : candidates[candidates.length - 1] || startMin);
}
